import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'edit-content-button',
    templateUrl: './edit-content-button.component.html',
    styleUrl: './edit-content-button.component.scss',
    standalone: false
})
export class EditContentButtonComponent {
  @Input() eventId: string;
  @Input() userId: string;

  constructor(private readonly router: Router) {}

  openEditContentPage(): void {
    this.router.navigate(['/edit-event', this.eventId]);
  }
}
